import { render, staticRenderFns } from "./SlarhNumberOverviewPage.vue?vue&type=template&id=972707c4&scoped=true&"
import script from "./SlarhNumberOverviewPage.vue?vue&type=script&lang=js&"
export * from "./SlarhNumberOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./SlarhNumberOverviewPage.vue?vue&type=style&index=0&id=972707c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972707c4",
  null
  
)

export default component.exports